import React from "react";
import { Link } from "react-router-dom";
import Avatar from "../../components/avatar/Avatar";
import Tags from "../../components/tags/Tags";
import Text from "../../components/typography/Text";
import useMedia from "../../hooks/useMedia";
import typesContext from "../../contexts/types";

export default designer => {
  const media = useMedia();
  const { skills, experiences } = React.useContext(typesContext);
  const {
    slug,
    name,
    country,
    city,
    job,
    avatar,
    level,
    skill = [],
    latest_works = []
  } = designer;
  const portfolio = latest_works
    .filter(Boolean)
    .filter(({ id }) => !!id)
    .map(work => ({
      id: work.id,
      alt: work.alt,
      image: work.base_path + work.breakpoints.lg["2x"]
    }));

  const designerSkills =
    skills && skill
      ? skill
          .map(skillId => {
            const skillData = skills.find(({ id }) => id === skillId);
            return skillData ? skillData.name : null;
          })
          .filter(Boolean)
      : [];

  return (
    <Link
      to={{
        pathname: `/designers/${slug}`,
        state: { designer, redirection: `/designers/${slug}` }
      }}
      className="noStyleLink"
    >
      <div className="oDesigner">
        <div className="oDesigner_picture">
          <Avatar avatar={avatar} />
        </div>
        <div className="oDesigner_infos">
          <div className="oDesigner_job">
            <Text small>{job}</Text>
          </div>
          <div className="oDesigner_name">
            <h4>{name}</h4>
          </div>
          {media !== "mobile" && (
            <>
              <div className="oDesigner_line">
                <div className="oDesigner_location">
                  <Text small>
                    {city}, {country}
                  </Text>
                </div>
                <div className="oDesigner_experience">
                  <Text small>{experiences[parseInt(level)]}</Text>
                </div>
              </div>
              <div className="oDesigner_tags">
                {skill && skills && <Tags tags={designerSkills} max={3} />}
              </div>
            </>
          )}
        </div>
        {media === "mobile" && (
          <>
            <div className="oDesigner_line">
              <div className="oDesigner_location">
                <Text small>
                  {city}, {country}
                </Text>
              </div>
              <div className="oDesigner_experience">
                <Text small>{experiences[level]}</Text>
              </div>
            </div>
            <div className="oDesigner_tags">
              <Tags tags={designerSkills} max={3} />
            </div>
          </>
        )}
        {portfolio && portfolio.length >= 1 && (
          <>
            <div className="oDesigner_portfolio">
              <div className="oDesigner_scroller">
                {portfolio && portfolio.length >= 1 && (
                  <div
                    className="oDesigner_project"
                    style={{
                      backgroundImage: `url(${portfolio[0].image})`
                    }}
                  ></div>
                )}
                {portfolio && portfolio.length >= 2 && (
                  <div
                    className="oDesigner_project"
                    style={{
                      backgroundImage: `url(${portfolio[1].image})`
                    }}
                  ></div>
                )}
                {media !== "mobile" && portfolio && portfolio.length >= 3 && (
                  <div
                    className="oDesigner_project"
                    style={{
                      backgroundImage: `url(${portfolio[2].image})`
                    }}
                  ></div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </Link>
  );
};
